import { useRewardContext } from 'contexts/useRewardContext'
import { useEffect, useState } from 'react'
import { getRateReward } from 'services/get-rate-reward'

export const SetReward = () => {
  const [amount, setAmount] = useState(0)
  const [hasZeroValue, setHasZeroValue] = useState(false)
  const [rate, setRate] = useState(0)
  const { steps: employees, updateStep, setCurrentStep } = useRewardContext()
  const fetchGetConversionRate = async () => {
    try {
      const response = await getRateReward()
      return response.rate
    } catch (error) {
      return 0
    }
  }

  useEffect(() => {
    const calculateTotalAmount = async () => {
      const conversionRate = await fetchGetConversionRate()
      setRate(conversionRate)
      const totalAmount =
        employees.reduce((acc, employee) => {
          const rewardValue = Number(employee.reward) || 0
          return acc + rewardValue
        }, 0) * conversionRate

      setAmount(totalAmount)
      setHasZeroValue(employees.some((employee) => employee.reward === 0))
    }

    calculateTotalAmount()
  }, [employees])

  const setHandleMillionValue = (value: number) => {
    if (value > 999) {
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    }
    return value
  }

  return (
    <section className="w-full h-full flex flex-col">
      <h1 className="text-xl leading-4 font-semibold">
        2. Definir quantidade de ViroCash
      </h1>

      <div className="w-full border-[1.5px] border-gray-200 rounded-2xl mt-4">
        {employees.map((employee, index) => (
          <div
            key={index}
            className="flex items-center justify-between gap-3 py-2 px-4 border-b-[1.5px] border-gray-200"
          >
            <span className="leading-7 font-medium">{employee.email}</span>

            <div className="flex items-center gap-2">
              <input
                type="text"
                value={setHandleMillionValue(employee.reward)}
                onChange={(e) => {
                  const inputValue = e.target.value
                    .replace(/\D/g, '')
                    .slice(0, 5)
                  if (inputValue === '') {
                    const newEmployee = {
                      ...employee,
                      reward: 0,
                      price: 0,
                    }
                    updateStep(index, newEmployee)
                    return
                  }

                  const isValid = /^\d+$/.test(inputValue)
                  if (!isValid) return

                  const numericValue = parseFloat(inputValue)

                  const newEmployee = {
                    ...employee,
                    reward: numericValue,
                    price: numericValue * rate,
                  }
                  updateStep(index, newEmployee)
                }}
                className="w-36 h-10 text-center text-lg border-[1.5px] border-gray-200 focus:outline-none focus:border-[#4F46E5] dark:border-gray-200"
              />

              <span className="text-[#4F46E5] text-sm font-semibold">
                ViroCash
              </span>
            </div>
          </div>
        ))}

        <div className="flex justify-end gap-4 py-4 px-4">
          <span className="font-bold">
            Total:{' '}
            <span className="text-[#4F46E5] text-lg">
              {amount.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </span>
          </span>
        </div>
      </div>

      <div className="flex justify-center items-center gap-10 mt-10">
        <button
          onClick={() => setCurrentStep(0)}
          className="bg-gray-100 dark:bg-transparent shadow border-[1.5px] rounded-full px-5 py-3 font-medium hover:opacity-95"
        >
          Voltar
        </button>
        <button
          onClick={() => setCurrentStep(2)}
          className={`
            bg-[#4F46E5] text-white rounded-full px-5 py-3 hover:opacity-95
            ${hasZeroValue ? 'cursor-not-allowed bg-[#4F46E5]/80' : ''}
          `}
          disabled={hasZeroValue}
        >
          Continuar
        </button>
      </div>
    </section>
  )
}
